export default __webpack_public_path__ + "static/media/PPCO_PREMIOS_IMPULSO_SUME_BY_SAINT_GOBAIN.e70e7698.pdf";